// extracted by mini-css-extract-plugin
export default {"menu__item":"ReceiptMenuList_menu__item__6eWT4"};